import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

/**
 * DropdownOption
 */
export interface DropdownOption {
	id: any;
	image: string;
}

@Component({
	selector: 'app-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.less']
})
export class DropdownComponent implements OnChanges {

	/**
	 * Opened
	 */
	public opened: boolean;

	/**
	 * SelectedOptionid
	 */
	 @Input()
	 public selectedOptionId: any;

	/**
	 * Options
	 */
	@Input()
	public dropdownOptions: DropdownOption[];

	/**
	 * Option selected output
	 */
	@Output()
	public selectedOptionChange: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Selected option id
	 */
	public selectedOption?: DropdownOption | null;

	/**
	 * Constructor
	 */
	constructor() {
		this.opened = false;
		this.dropdownOptions = [];
	}

	/**
	 * On changes
	 * @param changes changes
	 */
	public ngOnChanges(changes: SimpleChanges): void {
		this.opened = false;

		if (changes.options && this.dropdownOptions != null && this.dropdownOptions.length > 0) {
			this.selectOption(this.dropdownOptions[0].id);
		}

		if (changes.selectedOptionId && this.dropdownOptions != null) {
			this.selectedOption = this.dropdownOptions.find(o => o.id === this.selectedOptionId);
		}
	}

	/**
	 * Select option
	 */
	public selectOption(option: DropdownOption): void {
		this.opened = false;
		this.selectedOption = option;
		this.selectedOptionChange.emit(this.selectedOption.id);
	}

	/**
	 * Toggle
	 */
	public toggle(): void {
		this.opened = !this.opened;
	}
}
